window.addEventListener('scroll', function() {
    if (window.scrollY > 70) {
        document.body.classList.add('sticky_cstm');
    } else {
        document.body.classList.remove('sticky_cstm');
    }
});


let badges = document.querySelectorAll('.custom-badges');
let currentIndex = 0;

function cycleBadges() {
  // Hide all badges first
  badges.forEach(badge => {
    badge.classList.remove('show');
  });

  // Show the current badge
  badges[currentIndex].classList.add('show');
  
  // Move to the next badge
  currentIndex = (currentIndex + 1) % badges.length;
}

// Run the cycle every 2 seconds

if (badges.length > 0) {
setInterval(cycleBadges, 2000);
}


// Toggle the FAQ sections
document.querySelectorAll('.faq-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const faqItem = button.closest('.faq-item');
    const icon = button.querySelector('.toggle-icon');
    faqItem.classList.toggle('active');
    
    // Toggle between "▼" and "▲" for section header
    if (faqItem.classList.contains('active')) {
      icon.textContent = '-';  // Expand - change to up arrow
    } else {
      icon.textContent = '+';  // Collapse - change to down arrow
    }
  });
});

// Toggle the individual FAQ questions
if(document.querySelectorAll('.question-toggle').length > 0){
document.querySelectorAll('.question-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const question = button.closest('.faq-question');
    const icon = button.querySelector('.toggle-icon');
    const answerContent = question.querySelector('.answer-content');
    question.classList.toggle('active');
    
    // Toggle between "▼" and "▲" icon for questions
    if (question.classList.contains('active')) {
      icon.textContent = '-';  // Expand - change to up arrow
      answerContent.style.display = 'block';  // Show answer content
    } else {
      icon.textContent = '+';  // Collapse - change to down arrow
      answerContent.style.display = 'none';  // Hide answer content
    }
  });
});
}

$(document).ready(function(){
  // $("body").on('click','.cstm_product_coming .block-swatch',function(e){
  //   e.preventDefault();
  //   $(".peppy-notify-me-button-container").trigger("click");
  // });
  $("body").on('click','.cstm__judgeme_section',function(e){
    e.preventDefault();
    $(".jdgm-widget.jdgm-preview-badge.jdgm-preview-badge--with-link").trigger("click");
  });
  
   // search Place holder
  let staticPlaceholder = "I’m looking for ";
let searchArray = [
    "Dresses",
    "Co-ord Sets",
    "Tops",
    "Shirts",
    "Bottoms",
    "Basics",
    "Tie-Dye"
];
let dynamicPlaceholder = "";
let searchPlaceholderIndex = 0;
let offset = 0;
let len = searchArray.length;
let forwards = true;
let skipCount = 0;
let skipDelay = 10;
let speed = 100;

function type() {
    setInterval(function() {
        if (forwards) {
            if (offset >= searchArray[searchPlaceholderIndex].length) {
                ++skipCount;
                if (skipCount === skipDelay) {
                    forwards = false;
                    skipCount = 0;
                }
            }
        } 
        else {
            if (offset === 0) {
                forwards = true;
                searchPlaceholderIndex++;
                offset = 0;
                if (searchPlaceholderIndex >= len) {
                    searchPlaceholderIndex = 0;
                }
            }
        }
        dynamicPlaceholder = searchArray[searchPlaceholderIndex].substr(0, offset);
        if (skipCount === 0) {
            if (forwards) {
                offset++;
            } else {
                offset--;
            }
        }
        document.querySelectorAll('.header-search__input').forEach(searchEl => {
            searchEl.setAttribute("placeholder", staticPlaceholder + dynamicPlaceholder);
        });
    }, speed);
}

type();
  // End search Place holder
 
});  

var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="typewrite_wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 100 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 300;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
              new TxtType(elements[i], JSON.parse(toRotate), period);
            }
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .typewrite_wrap { border-right: 0 solid #fff}";
        document.body.appendChild(css);
};

